import React from 'react';

import AverageGrade from '~/src/features/reviews/components/AverageGrade';
import GradeHelp from '~/src/features/reviews/components/GradeHelp';
import GradesList from '~/src/features/reviews/components/GradesList';

import * as ST from './styled';

export interface IReviewData {
    date: string,
    text: string,
    grade: number,
    autor: string,
    source: string,
}

const Reviews = () => {
    return (
        <ST.Container>
            <ST.ReviewsGridContainer>
                <ST.ReviewsGridLocations>
                    <AverageGrade />
                    <GradesList />
                    <GradeHelp />
                </ST.ReviewsGridLocations>
            </ST.ReviewsGridContainer>
        </ST.Container>
    );
};

export default Reviews;
